import { api } from '@/apis';
import { dioStates } from '@/utils/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { endOfDay, startOfDay } from 'date-fns';

export function useTelematicsBoxPolls(imei, date) {
  const startTime = startOfDay(date);
  const endTime = endOfDay(date);

  const queryKey = ['telematicsBoxPolls', imei, startTime, endTime];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        {
          $match: {
            imei,
            enqueuedTime: {
              $gte: startTime,
              $lt: endTime,
            },
          },
        },
        {
          $project: {
            _id: false,
            time: true,
            position: true,
            ignitionOn: true,
            enqueuedTime: true,
            deviceProperties: {
              deviceSignalStrength: true,
              isValidated: true,
              batteryVoltage: true,
              driverId: true,
            },
            ...Object.fromEntries(
              Object.keys(dioStates).map((key) => [key, true]),
            ),
          },
        },
        { $sort: { enqueuedTime: 1 } },
      ];

      return await api
        .post('pipeline/telematicsBoxPolls', { json, signal })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
